import gaParams from '../../../utilities/analytics/constants';
import {gaEvent} from '../../../utilities/analytics/tracking';

export function gAUpdateContactAndAccountDetailsPageLoadedWithBenefit() {
  gaEvent(
    gaParams.PERSONAL_DETAILS_UPDATE_UPDATE_CONTACT_AND_ACCOUNT_DETAILS_WITH_BENEFIT_SHOW.category,
    gaParams.PERSONAL_DETAILS_UPDATE_UPDATE_CONTACT_AND_ACCOUNT_DETAILS_WITH_BENEFIT_SHOW.eventType,
    gaParams.PERSONAL_DETAILS_UPDATE_UPDATE_CONTACT_AND_ACCOUNT_DETAILS_WITH_BENEFIT_SHOW.eventParams
  );
}

export function gAUpdateContactAndAccountDetailsWithBenefitCheckboxAgreeTermsChecked() {
  gaEvent(
    gaParams.PERSONAL_DETAILS_UPDATE_UPDATE_CONTACT_AND_ACCOUNT_DETAILS_WITH_BENEFIT_CHECKBOX_AGREE_TERMS_CHECKED.category,
    gaParams.PERSONAL_DETAILS_UPDATE_UPDATE_CONTACT_AND_ACCOUNT_DETAILS_WITH_BENEFIT_CHECKBOX_AGREE_TERMS_CHECKED.eventType,
    gaParams.PERSONAL_DETAILS_UPDATE_UPDATE_CONTACT_AND_ACCOUNT_DETAILS_WITH_BENEFIT_CHECKBOX_AGREE_TERMS_CHECKED.eventParams
  );
}

export function gAUpdateContactAndAccountDetailsWithBenefitSubmit(status) {
  gaEvent(
    gaParams.PERSONAL_DETAILS_UPDATE_UPDATE_CONTACT_AND_ACCOUNT_DETAILS_WITH_BENEFIT_BUTTON_CLICK_UPDATE_DETAILS.category,
    gaParams.PERSONAL_DETAILS_UPDATE_UPDATE_CONTACT_AND_ACCOUNT_DETAILS_WITH_BENEFIT_BUTTON_CLICK_UPDATE_DETAILS.eventType,
    status
  );
}

export function gAUpdateContactAndAccountDetailsSuccess(status) {
  gaEvent(
    gaParams.PERSONAL_DETAILS_UPDATE_UPDATE_CONTACT_AND_ACCOUNT_DETAILS_SUCCESS.category,
    gaParams.PERSONAL_DETAILS_UPDATE_UPDATE_CONTACT_AND_ACCOUNT_DETAILS_SUCCESS.eventType,
    status
  );
}
export function gAUpdateContactAndAccountDetailsFailed(status) {
  gaEvent(
    gaParams.PERSONAL_DETAILS_UPDATE_UPDATE_CONTACT_AND_ACCOUNT_DETAILS_FAILED.category,
    gaParams.PERSONAL_DETAILS_UPDATE_UPDATE_CONTACT_AND_ACCOUNT_DETAILS_FAILED.eventType,
    status
  );
}

export function gAUpdateContactAndAccountDetailsFailedBenefitIssue(status) {
  gaEvent(
    gaParams.PERSONAL_DETAILS_UPDATE_UPDATE_CONTACT_AND_ACCOUNT_DETAILS_FAILED_BENEFIT_ISSUE.category,
    gaParams.PERSONAL_DETAILS_UPDATE_UPDATE_CONTACT_AND_ACCOUNT_DETAILS_FAILED_BENEFIT_ISSUE.eventType,
    status
  );
}

export function gAUpdateContactAndAccountDetailsPageLoadedWithoutBenefit() {
  gaEvent(
    gaParams.PERSONAL_DETAILS_UPDATE_UPDATE_CONTACT_AND_ACCOUNT_DETAILS_WITHOUT_BENEFIT_SHOW.category,
    gaParams.PERSONAL_DETAILS_UPDATE_UPDATE_CONTACT_AND_ACCOUNT_DETAILS_WITHOUT_BENEFIT_SHOW.eventType,
    gaParams.PERSONAL_DETAILS_UPDATE_UPDATE_CONTACT_AND_ACCOUNT_DETAILS_WITHOUT_BENEFIT_SHOW.eventParams
  );
}

export function gAUpdateContactAndAccountDetailsWithoutBenefitSubmit(status) {
  gaEvent(
    gaParams.PERSONAL_DETAILS_UPDATE_UPDATE_CONTACT_AND_ACCOUNT_DETAILS_WITHOUT_BENEFIT_BUTTON_CLICK_UPDATE_DETAILS.category,
    gaParams.PERSONAL_DETAILS_UPDATE_UPDATE_CONTACT_AND_ACCOUNT_DETAILS_WITHOUT_BENEFIT_BUTTON_CLICK_UPDATE_DETAILS.eventType,
    status
  );
}

export function gAUpdateContactAndAccountDetailsWithoutBenefitCheckboxAgreeTermsChecked() {
  gaEvent(
    gaParams.PERSONAL_DETAILS_UPDATE_UPDATE_CONTACT_AND_ACCOUNT_DETAILS_WITHOUT_BENEFIT_CHECKBOX_AGREE_TERMS_CHECKED.category,
    gaParams.PERSONAL_DETAILS_UPDATE_UPDATE_CONTACT_AND_ACCOUNT_DETAILS_WITHOUT_BENEFIT_CHECKBOX_AGREE_TERMS_CHECKED.eventType,
    gaParams.PERSONAL_DETAILS_UPDATE_UPDATE_CONTACT_AND_ACCOUNT_DETAILS_WITHOUT_BENEFIT_CHECKBOX_AGREE_TERMS_CHECKED.eventParams
  );
}
